import { render, staticRenderFns } from "./wUpload.vue?vue&type=template&id=59752949&scoped=true&"
import script from "./wUpload.vue?vue&type=script&lang=js&"
export * from "./wUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59752949",
  null
  
)

export default component.exports